import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import config from '../../config';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Form,
  FieldCheckboxGroup,
  FieldCurrencyInput,
  PrimaryButton,
} from '../../components';
import css from './EditListingPricingForm.css';

const { Money } = sdkTypes;

export const EditListingPricingFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        className,
        disabled,
        handleSubmit,
        intl,
        invalid,
        pristine,
        ready,
        saveActionMsg,
        updated,
        updateError,
        updateInProgress,
      } = fieldRenderProps;

      const fullDayPriceLabel = intl.formatMessage({ id: 'EditListingPricingForm.fullDayPrice.label' });
      const fullDayPricePlaceholderMessage = intl.formatMessage({ id: 'EditListingPricingForm.fullDayPrice.placeholder' });
      const paidExtrasLabel = intl.formatMessage({ id: 'EditListingPricingForm.paidExtras.label' });
      const { paidExtras } = config.custom;
      const errorMessage = updateError ? (
        <p className={css.error}>
          <FormattedMessage id='EditListingPricingForm.updateFailed' />
        </p>
      ) : null;

      const priceLabel = intl.formatMessage({ id: 'EditListingPricingForm.price.label' });
      const pricePlaceholderMessage = intl.formatMessage({ id: 'EditListingPricingForm.price.placeholder' });

      const priceRequired = validators.required(intl.formatMessage({ id: 'EditListingPricingForm.price.required' }));
      const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
      const minPriceRequired = validators.moneySubUnitAmountAtLeast(
        intl.formatMessage(
          {
            id: 'EditListingPricingForm.priceTooLow',
          },
          {
            minPrice: formatMoney(intl, minPrice),
          }
        ),
        config.listingMinimumPriceSubUnits
      );
      const priceValidators = config.listingMinimumPriceSubUnits
        ? validators.composeValidators(priceRequired, minPriceRequired)
        : priceRequired;

      const classes = classNames(css.root, className);
      const submitReady = updated && pristine || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress || ready;

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {errorMessage}
          <FieldCurrencyInput
            id="price"
            name="price"
            className={css.priceInput}
            label={priceLabel}
            placeholder={pricePlaceholderMessage}
            currencyConfig={config.currencyConfig}
            validate={priceValidators}
          />
          <p className={css.tip}>
            <FormattedMessage id="EditListingPricingForm.price.tip" />
          </p>
          <FieldCurrencyInput
            id="fullDayPrice"
            name="fullDayPrice"
            className={css.priceInput}
            label={fullDayPriceLabel}
            placeholder={fullDayPricePlaceholderMessage}
            currencyConfig={config.currencyConfig}
          />
          <div className={css.extrasContainer}>
            <FieldCheckboxGroup
              className={css.paidExtras}
              id="paidExtras"
              name="paidExtras"
              label={paidExtrasLabel}
              options={paidExtras}
              twoColumns={false}
            />
          </div>
          <div className={css.buttonContainer}>
            <PrimaryButton
              className={css.submitButton}
              type='submit'
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingPricingFormComponent.defaultProps = { updateError: null };

const { bool, func, string } = PropTypes;

EditListingPricingFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  ready: bool,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
};

export default compose(injectIntl)(EditListingPricingFormComponent);



// WEBPACK FOOTER //
// ./src/forms/EditListingPricingForm/EditListingPricingForm.js